<template>
    <div>
        <el-upload
            ref="elUploader"
            action="/media/upload/image"
            list-type="picture-card"
            :accept="accept"
            :limit="limit"
            :on-success="handleUploadSuccess"
            :on-exceed="handleExceed"
            :on-preview="handleImagePreview"
            :on-remove="handleImageRemove"
            :on-change="handleChange"
            :on-error="handleError"
            :auto-upload="autoUpload"
            >
            <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="previewVisible">
            <img width="100%" :src="previewImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
import * as qiniu from 'qiniu-js';
function noop() {}
export default {
    name: "QiniuElUpload",
    props: {
        onError: {
            type: Function,
            default: noop
        },
        onRemove: {
            type: Function,
            default: noop
        },
        onExceed: {
            type: Function,
            default: noop
        },
        accept:
        {
            type: String,
            default: "*/*"
        },
        limit:
        {
            type: Number,
            default: 1
        }
    },
    data()
    {
        return {
            autoUpload: false,
            previewImageUrl: '',
            previewVisible: false,
            fileList: null
        }
    },
    methods:
    {
        handleUploadSuccess(response, file, fileList)
        {
            console.log(response);
            // this.form.url = response.data.path;
            // this.form.mediaId = response.data.mediaId;
            // this.onSuccess(response, file, fileList);
        },
        handleImageRemove(file, fileList)
        {
            console.log(file, fileList);
            // this.form.url = '';
            this.fileList = fileList;
            this.onRemove(file, fileList);
        },
        handleImagePreview(file)
        {
            this.previewImageUrl = file.url;
            this.previewVisible = true;
        },
        handleExceed(files,fileList)
        {
            this.showMessageError('最多只能上传一张');
        },
        handleChange(file, fileList)
        {
            this.fileList = fileList;
        },
        handleError(event, file, fileList)
        {
            this.onError(event, file, fileList);
        },
        validate()
        {
            if(!this.fileList || !this.fileList.length)
            {
                return '请选择文件';
            }
            if(this.fileList.length > this.limit)
            {
                return '文件超出数量';
            }
            return '';
        },
        upload()
        {
            if(!this.fileList || !this.fileList.length)
            {
                this.showMessageError('请选择文件');
                return Promise.reject('请选择文件');
            }
            console.log(this.fileList);
            let uploadedList= [];
            return Fx.Promise.foreach(this.fileList, (file, i)=>
            {
                return Fx.Http.post("/System/Qiniu/GenerateUpToken").
                then((res)=>
                {
                    console.log(res);
                    if(res.isSuccess())
                    {
                        let uploadKey = res.getData('uploadKey');
                        let token = res.getData('token');
                        let qiniuUrl = res.getData('qiniuUrl');
                        return new Promise((resolve, reject)=>
                        {
                            let observerable = qiniu.upload(file.raw, uploadKey, token, {},
                                {
                                    fname : file.raw.name,
                                    mimeType: [ this.accept ]
                                });
                            let subscription = observerable.subscribe((res)=>
                                {
                                    // console.log(res, res&&res.total.percent>=100);
                                    if(res&&res.total&&res.total.percent>=100)
                                    {
                                        uploadedList.push({
                                            uploadKey: uploadKey,
                                            url: `${qiniuUrl}/${uploadKey}`
                                        });
                                        resolve(res);
                                    }
                                },
                                (err)=>
                                {
                                    console.error('上传失败：',err)
                                    this.showMessageError(err.message||'上传失败');
                                    reject(err);
                                },
                                (res)=>{});
                        });
                    }
                    else
                    {
                        this.showMessageError('获取上传凭证失败！');
                    }
                });
            }).
            then(()=>
            {
                console.log('uploadedList:', uploadedList);
                return uploadedList;
            });
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/QiniuElUpload.vue